document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".js-core-card");

  let activeCard = null;
  let overlay = null;
  let placeholder = null;

  function closeCard() {
    if (!activeCard) return;

    // devolver la card a su sitio original
    placeholder.replaceWith(activeCard);

    activeCard.classList.remove("is-expanded");
    document.body.style.overflow = "";

    overlay.remove();

    activeCard = null;
    overlay = null;
    placeholder = null;
  }

  cards.forEach(card => {
    card.addEventListener("click", () => {
      if (activeCard) return;

      activeCard = card;

      // placeholder para mantener el hueco en el grid
      placeholder = document.createElement("div");
      placeholder.style.height = `${card.offsetHeight}px`;
      placeholder.style.width = "100%";

      card.parentNode.replaceChild(placeholder, card);

      // overlay
      overlay = document.createElement("div");
      overlay.className = "core-overlay";
      document.body.appendChild(overlay);

      overlay.appendChild(card);
      card.classList.add("is-expanded");

      document.body.style.overflow = "hidden";

      // click fuera
      overlay.addEventListener("click", e => {
        if (e.target === overlay) closeCard();
      });
    });
  });

  // cerrar con ESC
  document.addEventListener("keydown", e => {
    if (e.key === "Escape") closeCard();
  });
});
